module.exports = __webpack_public_path__ + "missive-wordmark-52c52ac119158cec879ab893302ab04a.webp";